import { useState, useEffect } from 'react';
import Lottie, { LottieOptions } from 'lottie-react';
import { Typography } from '@vivaahealth/design-system';

import styles from './index.module.css';

interface Title {
  text: string;
  msInterval: number;
}

interface Props extends LottieOptions {
  titles: Title[];
  msInterval: number;
  onIntervalEnd: () => void;
}

export const Animation: React.FC<Props> = (props) => {
  const { titles, msInterval, onIntervalEnd } = props;
  const [title, setTitle] = useState('');
  useEffect(() => {
    const titleTimers = titles.map((t, i) => {
      return setTimeout(() => setTitle(t.text), t.msInterval * i);
    });
    const intervalEndTimer = setTimeout(() => onIntervalEnd(), msInterval);
    return () => {
      [...titleTimers, intervalEndTimer].forEach((t) => clearTimeout(t));
    };
  }, [titles, msInterval, onIntervalEnd]);
  return (
    <>
      <div className={styles.TitleContainer}>
        <Typography variant="headline-small" bold>
          {title}
        </Typography>
      </div>
      <div className={styles.AnimationContainer}>
        <Lottie {...props} />
      </div>
    </>
  );
};
